<template>
    <div>
        <h1>Welcome to My Vue App</h1>
        <div class="gcse-search" id="search-box"></div>
        <div id="bcs_js_snippet"></div>
        <div>
            <form action="https://www.google.com/search" method="get" target="_blank">
                <input type="text" name="q" placeholder="站内搜索...">
                <input type="hidden" name="sitesearch" value="172.16.249.135:8080">
                <input type="submit" value="搜索">
            </form>
            <div class="one">
                吴大维达瓦达瓦达瓦低洼地awdadsadasdads
            </div>
            <div class="two">
                吴大维达瓦达瓦达瓦低洼地awdadsadasdads
            </div>
            <iframe :src="'https://www.google.com/search?q=111&sitesearch=172.16.249.135:8080'" width="100%"
                height="500"></iframe>
        </div>
    </div>
</template>
  
<script>
export default {
    mounted() {
        this.initializeSearchBox();
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'bcs_js_snippet';
        script.src = "https://ui.customsearch.ai/api/ux/rendering-js?customConfig=0744f843-0080-4f8b-b031-aaff97739e99&market=en-US&version=latest&q=";
        this.googleSearch()
        document.head.appendChild(script);
    },
    activated() {
        this.initializeSearchBox();
    },
    methods: {
        googleSearch() {
            this.$axios({
                method: 'get',
                url: 'https://www.google.com/search?q=' + '111&sitesearch=172.16.249.135:8080',
            }).then(results => {
                console.log(results);

            })
        },
        searchCallback() {
            var query = document.getElementById("search-box").value;
            var searchUrl = "https://www.google.com/search?q=" + encodeURIComponent(query);
            var win = window.open(searchUrl, "_blank", "width=800,height=600,scrollbars=yes");
            win.focus();
            return false;
        },
        initializeSearchBox() {
            if (document.readyState === 'complete') {
                console.log(google.search.cse);
                google.search.cse.element.render({
                    div: "search-box",

                    attributes: {
                        onsubmit: "return false;"
                    }
                });
            } else {
                google.setOnLoadCallback(function () {
                    google.search.cse.element.render({
                        div: "search-box",

                        attributes: {
                            onsubmit: "return false;"
                        }
                    });
                }, true);
            }
        }
    }
}
</script>
<style>
form {
    display: flex;
    align-items: center;
}

input[type="text"] {
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

input[type="submit"] {
    margin-left: 10px;
    padding: 6px 12px;
    background-color: #f8f9fa;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
.one{
    font-family: HYZhengYuan-65W;
    font-size: 14px;
}
.two{
    font-family: HYZhengYuan-65W;
    font-size: 14px;
}
</style>